import { BreastCancerRiskType, NodeTypes, PageNode, TextQuestionType, ComponentSizes } from '@myriadgenetics/mgh-types';
import { BreastCancerRiskNodeOptions } from './types';

export default ({ continueType, subtitle, baseKey, type, includesBreastDensity }: BreastCancerRiskNodeOptions): PageNode => {
  return {
    id: -5013,
    description: 'Built-in page node',
    name: 'Hormone Therapy Expected input',
    type: NodeTypes.Page,
    data: {
      continueType,
      subtitle,
      pageTitleKey: 'pageTitles.hormoneTherapyExpectedInputNode',
    },
    components: [
      {
        id: -14,
        description: 'Built in component',
        name: 'Expected Hormone Therapy Input',
        type: 'TEXT_QUESTION',
        data: {
          answerKey: `${baseKey}.hormoneTherapyExpectedInput`,
          questionKey: 'breastCancerRisk.hormoneTherapyExpectedInput',
          labelKey: 'breastCancerRisk.yearsLabel',
          placeholderKey: '',
          inputType: TextQuestionType.Number,
          size: ComponentSizes.Large,
          required: type === BreastCancerRiskType.TcScore,
          secondaryResponse: {
            textKey: 'breastCancerRisk.dontKnow',
            value: type === BreastCancerRiskType.TcScore ? ' ' : null,
          },
        },
      },
    ],
    flows: [
      {
        id: -13,
        name: 'Expected Hormone Therapy Flow',
        description: 'Built-in flow',
        type: 'UNCONDITIONAL',
        data: {
          nextPageId: includesBreastDensity ? -5019 : -5015,
        },
      },
    ],
  };
};
